import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UiService } from './ui/ui.service';
import Elpong from 'elpong';
var AppComponent = /** @class */ (function () {
    function AppComponent(httpClient, ui) {
        var _this = this;
        this.httpClient = httpClient;
        this.ui = ui;
        Elpong.setAjax(httpClient, 'angular2');
        Elpong.get('greenplease').setApiUrl('/api');
        ui.title$.subscribe(function (t) {
            if (!!t)
                _this.lastTitle = t;
            _this.titleVisible = !!t;
        });
    }
    AppComponent.prototype.ngOnInit = function () {
    };
    return AppComponent;
}());
export { AppComponent };
//# sourceMappingURL=app.component.js.map